<!--
 * @Author: lwk
 * @Date: 2024-01-24 09:28:09
 * @LastEditors: lwk
 * @LastEditTime: 2024-03-11 10:23:19
 * @Description: 请填写简介
-->
<!--
 * @Author: 
 * @Date: 2024-01-24 09:28:09
 * @LastEditors: lwk
 * @LastEditTime: 2024-01-25 10:58:07
 * @Description: 日行一善s
-->
<template>
  <div class="staticdayqing">
    <el-row type="flex" justify="space-between">
      <el-row class="row-bg" style="position: relative;">
        <el-col :span="10">
          <div style="position: absolute;right: 0;">
            <el-radio-group
              v-model="dateType"
              size="mini"
              @input="changeDate($event, 'countNum')"
              style="display: flex;"
            >
              <el-radio-button label="month">本月</el-radio-button>
              <el-radio-button label="quarter">本季度</el-radio-button>
              <el-radio-button label="year">本年</el-radio-button>
            </el-radio-group>
          </div>
          <el-row>
            <h3>综合数量统计</h3>
            <div class="comprehensive">
              <div
                v-for="item in comprehensiveList"
                :key="item.prop"
                class="itemCircle"
              >
                <span>{{ item.label }}</span>
                <span>{{ rqData[item.prop] }}</span>
              </div>
              <div class="itemCircle">
                <span>平均点评率</span>
                <span>{{
                  (((rqData["rq_comment_num"] / rqData["rq_num"]) * 100).toFixed(
                    2
                  ) + "%")
                }}</span>
              </div>
            </div>
          </el-row>
        </el-col>
      </el-row>
      <el-row>
        <div style="display: flex;justify-content: space-between;">
          <h3>未按时点评通告</h3>
          <el-radio-group
            v-model="dateTypeRight"
            size="mini"
            @input="changeDate($event, 'nocountNum')"
            style="display: flex;"
          >
            <el-radio-button label="month">本月</el-radio-button>
            <el-radio-button label="quarter">本季度</el-radio-button>
            <el-radio-button label="year">本年</el-radio-button>
          </el-radio-group>
        </div>
        <el-table :data="tableData" style="width: 450px;" height="300">
          <el-table-column
            label="序号"
            type="index"
            width="100"
            align="center"
          />
          <el-table-column prop="dept_name" label="部门" align="center" />
          <el-table-column prop="rq_num" label="发送数" align="center" />
          <el-table-column
            prop="rq_comment_num"
            label="点评数"
            align="center"
          />
        </el-table>
        <div style="display: flex;justify-content: center;margin-top: 10px;">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            @current-change="checkPage"
          >
          </el-pagination>
        </div>
      </el-row>
    </el-row>
    <el-row style="margin-top: 20px;">
      <div style="float: right;">
        <el-radio-group
          v-model="dateTypeBottom"
          size="mini"
          @input="changeDate($event, 'deptList')"
          style="display: flex;position: relative;z-index: 99;"
        >
          <el-radio-button label="month">本月</el-radio-button>
          <el-radio-button label="quarter">本季度</el-radio-button>
          <el-radio-button label="year">本年</el-radio-button>
        </el-radio-group>
      </div>
      <div id="dayQingId"></div>
    </el-row>
  </div>
</template>

<script>
import { countNum, notCommentList, deptList } from "@/api/dayqing";
import moment from "moment";
import * as echarts from "echarts";
export default {
  name: "DayQingData",
  data() {
    return {
      form: {
        departmentName: "",
        searchName: "",
        beginTime: "",
        endTime: ""
      },
      dateTime: [
        moment()
          .subtract(1, "days")
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss"),
        moment()
          .subtract(1, "days")
          .endOf("day")
          .format("YYYY-MM-DD HH:mm:ss")
      ],
      dateType: "month",
      dateTypeRight: "month",
      dateTypeBottom: "month",
      tableData: [],
      tableDataPerson: [],
      pageType: {
        pageNum: 1,
        pageSize: 10
      },
      total: undefined,
      comprehensiveList: [
        {
          label: "日清发送人数",
          prop: "rq_creator_num"
        },
        {
          label: "日清发送总数",
          prop: "rq_num"
        },
        {
          label: "日清点评总数",
          prop: "rq_comment_num"
        }
      ],
      rqData: {},
      sourceDataDay:[]
    };
  },
  mounted() {
    setTimeout(() => {
      this.initEcharts();
      this.changeDate("month", "countNum");
      this.changeDate("month", "nocountNum");
      this.changeDate("month", "deptList");
    }, 500);
  },
  methods: {
    async changeDate(val, type) {
      switch (val) {
        case "month":
          this.beginTime = moment()
            .startOf("month")
            .format("YYYY-MM-DD HH:mm:ss");
          this.endTime = moment()
            .endOf("month")
            .format("YYYY-MM-DD HH:mm:ss");
          break;
        case "quarter":
          this.beginTime = moment()
            .startOf("quarter")
            .format("YYYY-MM-DD HH:mm:ss");
          this.endTime = moment()
            .endOf("quarter")
            .format("YYYY-MM-DD HH:mm:ss");

          break;
        case "year":
          this.beginTime = moment()
            .startOf("year")
            .format("YYYY-MM-DD HH:mm:ss");
          this.endTime = moment()
            .endOf("year")
            .format("YYYY-MM-DD HH:mm:ss");

          break;

        default:
          break;
      }
      const methodType = {
        countNum: this.getEchartData,
        nocountNum: this.notCommentList,
        deptList: this.deptList
      };
      methodType[type]();
    },
    initEcharts() {
      var chartDom = document.getElementById("dayQingId");
      var chartsOption = {
        title: {
          text: "日清发送/点评统计"
        },
        legend: {
          // right: 100,
          // top: 20,
          textStyle: {
            align: "center" // 水平对齐方式为居中
          }
        },
        tooltip: {},
        grid: {
          left: "3%",
          right: "4%",
          bottom: "1%",
          containLabel: true
        },
        dataset: {
          dimensions: ["product", "发送", "点评"],
          source: this.sourceDataDay
        },
        xAxis: { type: "category" },
        yAxis: { name: "（得分）" },
        // Declare several bar series, each will be mapped
        // to a column of dataset.source by default.
        series: [
          {
            type: "bar",
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#83bff6" },
                { offset: 0.5, color: "#188df0" },
                { offset: 1, color: "#188df0" }
              ])
            }
          },
          {
            type: "bar",
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#cfe8d5" },
                { offset: 0.5, color: "#55b74f" },
                { offset: 1, color: "#3c6e3f" }
              ])
            }
          }
        ]
      };
      this.myChart = echarts.init(chartDom);
      chartsOption && this.myChart.setOption(chartsOption);
    },
    async getEchartData() {
      const params = {
        beginTime: this.beginTime,
        endTime: this.endTime
      };
      const { code, data } = await countNum(params);
      if (code != 0) return;
      this.rqData = data;
      // [
      //   ["Matcha Latte", 85.8, 93.7],
      //   ["Milk Tea", 73.4, 55.1],
      //   ["Cheese Cocoa", 65.2, 82.5],
      //   ["Walnut Brownie", 53.9, 39.1]
      // ]
      // this.sourceDataDay = data.map(item => {
      //   return [item.employeeName, item.dp, item.dz];
      // });
      // this.myChart.setOption({
      //   dataset: {
      //     source: this.sourceDataDay
      //   }
      // });
    },
    async notCommentList() {
      const params = {
        beginTime: this.beginTime,
        endTime: this.endTime
      };
      const { code, rows, total } = await notCommentList({
        ...params,
        ...this.pageType
      });
      if (code != 0) return;
      this.tableData = rows;
      this.total = total;
    },
    // 日清发送/点评统计
    async deptList() {
      const params = {
        beginTime: this.beginTime,
        endTime: this.endTime
      };
      const { code, rows } = await deptList(params);
      if (code != 0) return;
      this.sourceDataDay = rows.map(item => {
        return [item.dept_name, item.rq_num, item.rq_comment_num];
      });
      this.myChart.setOption({
        dataset: {
          source: this.sourceDataDay
        }
      });
    },
    checkPage(val) {
      this.pageType.pageNum = val;
    }
  }
};
</script>

<style lang="scss" scoped>
.staticdayqing {
  .dayqing {
    display: flex;
    justify-content: space-between;
  }
}
#dayQingId {
  width: 100%;
  height: 260px;
}
.comprehensive {
  display: flex;
  width: 800px;
  margin-top: 50px;
  justify-content: space-between;
  .itemCircle {
    width: 140px;
    height: 140px;
    border-radius: 50%;
    background: #188df0;
    display: flex;
    flex-direction: column;
    color: #fff;
    justify-content: center;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DayQing/DayStatistics.vue